import React, { useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { Box, Typography, IconButton } from '@mui/material';
import CustomTextField from "../CustomTextField";
import CloseIcon from '@mui/icons-material/Close';


const DecorationMatrixTable = ({ columns, data, onColumnsChange, onDataChange, isEditMode }) => {
  const [editingColumns, setEditingColumns] = useState(columns);
  const handleCellChange = (rowIndex, columnId, value) => {
    const updatedData = [...data];
    updatedData[rowIndex][columnId] = value;
    onDataChange(updatedData);
  };
  const handleHeaderBlur = (colIndex) => {
    const updatedColumns = [...editingColumns];
    const currentColumn = updatedColumns[colIndex];
    if (!currentColumn?.header) return;

    let start = Number(currentColumn.header?.start);
    let end = Number(currentColumn.header?.end);

    if (isNaN(start)) return;

    if (start > end) {
      end = start + 1;
      currentColumn.header.start = start.toString();
      currentColumn.header.end = end.toString();

      if (colIndex > 1) {
        const prevColumn = updatedColumns[colIndex - 1];
        prevColumn.header.end = (start - 1).toString();
      }
    }
    if (start < end) {
      if (colIndex > 1) {
        updatedColumns[colIndex - 1].header.end = start - 1;
      }
    }
    for (let i = colIndex + 1; i < updatedColumns.length; i++) {
      const prevEnd = Number(updatedColumns[i - 1]?.header?.end);
      const newStart = prevEnd + 1;
      const newEnd = newStart + 1;

      updatedColumns[i].header.start = newStart.toString();
      updatedColumns[i].header.end = newEnd.toString();
    }

    onColumnsChange(updatedColumns);
    setEditingColumns(updatedColumns);
  };


  const dynamicColumns = columns.map((col, colIndex) => {

    return ({
      accessorKey: col.accessorKey,

      header: col.accessorKey !== 'Unit' && col.accessorKey !== 'Cost' && typeof col.header === 'object' && col.header !== null ? (
        <Box sx={{ width: '100%', display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {isEditMode ? <Box className="field" sx={{ width: '100px' }}>
            <CustomTextField
              name={col.id}
              placeholder="Price"
              value={col.header?.start}
              handleChange={(e) => {
                const updated = [...editingColumns];
                if (updated?.[colIndex] && updated[colIndex]?.header) {
                  updated[colIndex].header.start = e.target.value;
                  setEditingColumns(updated);
                }

              }}
              handleBlur={(e) => handleHeaderBlur(colIndex)}
            />
          </Box> : <Typography >{col.header?.start}</Typography>
          }
          <Typography sx={{ marginLeft: '10px' }}>{` - ${col.header?.end}`}</Typography>
        </Box>
      ) : col.accessorKey === 'Cost' || (col.accessorKey !== 'Unit' && typeof col.header !== 'object') ? (
        <Box>
          <Typography sx={{ marginLeft: '10px' }}>{col.header}</Typography>
        </Box>
      ) :
        (
          <Box className="field">
            {isEditMode ? <CustomTextField
              name={col.id}
              placeholder={col.header}
              value={col.header}

              handleChange={(e) => {
                const updatedColumns = [...columns];
                updatedColumns[colIndex] = {
                  ...updatedColumns[colIndex],
                  header: e.target.value
                };
                onColumnsChange(updatedColumns);
              }}
            /> :
              <Typography sx={{ marginLeft: '10px' }}>{col.header}</Typography>
            }
          </Box>
        ),

      enableSorting: false,
      enableColumnFilter: false,
      size: 100,
      minSize: 80,
      maxSize: 120,

      Cell: ({ row, column, setData }) => (
        <Box className="field">
          {isEditMode ? <Box sx={{
            display: 'flex',
          }}>
            {column.accessorKey === 'Unit' && <IconButton className="delete-icon" aria-label="delete" size="large">
              <CloseIcon fontSize="small" />
            </IconButton>}
            <CustomTextField
              name={column.id}
              placeholder={column.header}
              value={row.original[column.id]}
              handleChange={(e) => handleCellChange(row.index, column.id, e.target.value)}
            />
          </Box> : <Typography>{row.original[column.id]}</Typography>}
        </Box>
      )
    });
  });
  if (isEditMode) {
    dynamicColumns.unshift({
      id: 'delete',
      header: '',
      size: 50,
      Cell: ({ row }) => (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            '&:hover .delete-icon': {
              visibility: 'visible',
            },
          }}
        >
          <IconButton
            className="delete-icon"
            aria-label="delete"
            onClick={() => {
              const updatedData = [...data];
              updatedData.splice(row.index, 1);
              onDataChange(updatedData);
            }}
            sx={{
              visibility: 'hidden',
              color: 'red',
            }}
            size="large">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      ),
      enableSorting: false,
      enableColumnFilter: false,
    });
  }

  useEffect(() => {
    setEditingColumns(columns);
  }, [columns]);
  const firstColumnId = columns[0]?.accessorKey

  return (
    <Box sx={{
      marginTop: '30px'
    }}>
      <MaterialReactTable
        columns={dynamicColumns}
        data={data}
        enablePagination={false}
        layoutMode="grid-no-grow"
        enableColumnPinning={true}
        enableSorting={false}
        enableColumnFilters={false}
        enableColumnActions={false}
        enableTopToolbar={false}
        enableBottomToolbar={false}

        muiTableProps={{
          sx: {
            tableLayout: 'fixed',
          },
        }}

        muiTableHeadCellProps={({ column }) => {
          const isFirstColumn = column.id === firstColumnId;

          return ({
            sx: {
              backgroundColor: '#f0f0f0',
              fontWeight: 'bold',
              position: isFirstColumn ? 'sticky' : '',
              left: isFirstColumn ? 0 : '',
              backgroundColor: '#f5f5f5',
              zIndex: isFirstColumn ? 2 : '',
              fontWeight: 'bold',

            },
          })
        }}

        muiTableContainerProps={{
          sx: {
            border: '1px solid #ccc',
            borderRadius: '6px',
          },
        }}

        muiTableBodyCellProps={({ column }) => {
          const isFirstColumn = column.id === firstColumnId;
          const isDeleteColumn = column.id === 'delete';
          return ({
            sx: {
              position: isFirstColumn ? 'sticky' : '',
              left: isFirstColumn ? 0 : '',
              zIndex: isFirstColumn ? 1 : '',
              '&:hover .delete-icon': {
                visibility: isDeleteColumn ? 'visible' : 'hidden',
              },
            }
          })
        }}
      />
    </Box>
  );
};

export default DecorationMatrixTable;










